const ROLES = {
    ZTUDENT: 1,
    INSTRUCTOR: 2,
    PROJECT_LEADER: 3,
    DISTRIBUTOR: 4
}

export { ROLES };